$(document).on('turbo:load turbo:render', () => {


    enableSubmitWhen2Selected();
    $('.duplicates-listing input').on("change",function() {
        $(this).closest('form').submit();

    });


    $(".cancel-selection").on("click", (e)=>{
        e.preventDefault();
       let id = e.currentTarget.id;
        $(".duplicates-listing").find("input:checkbox").each((i, checkbox)=>{
            let $checkbox = $(checkbox);
            if ($checkbox.val()== id){
                $checkbox.trigger("click");
            }
        })
    });
});




function enableSubmitWhen2Selected(){
    let count = 0;
    $(".duplicates-listing").find("input:checkbox").each((i, checkbox)=>{
        if ($(checkbox).is(":checked")){
            count++;
        }
    });
    if (count == 2 ){
        // @ts-ignore
        $(".duplicates-listing").find("input:submit").attr("disabled", false);

    }
    else{
        $(".duplicates-listing").find("input:submit").attr("disabled", "true");

    }
}